/**
 * Which kind of promise a SAFE valuation cap makes. A pre-money cap fixes a price per share
 * (cap / pre-conversion fully diluted shares) and therefore a share count; a post-money cap fixes a
 * percentage of the post-conversion cap table (investment / cap). A SAFE has at most one cap, so
 * the type is stored next to the cap amount and is null when the SAFE has no cap.
 */
export enum SafeCapType {
  POST_MONEY = 'post-money',
  PRE_MONEY = 'pre-money',
}
